module.exports = __webpack_public_path__ + "img/profile-blank.ade5becf.webp";